import React, { useState, useEffect, useContext } from "react";
import { TouchableOpacity, StyleSheet, ScrollView } from "react-native";
import { Text, View } from "../../../components/shared/Themed";
import {
  headers,
  MediumDeviceHeaders,
  SmallDeviceHeaders,
} from "./createUserHeaders";
import Modal from "../../../components/custom/Modal";
import CreateOktaBypassUserAccountForm from "./CreateOktaBypassUserAccountForm";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { NestedDataTable } from "../../../components/custom/DataTable/NestedDataTableWithPagination2";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUsers,
  searchAllUsers,
} from "../../../redux/dispatcher/usersDispatcher";
import { LabelBannerWithSearchBar } from "../../../components/custom/Banners/LabelBannerWithSearchBar";

export default function CreateUserSettingsScreen({ navigation }: any) {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const [isRefresh, setRefresh] = useState(false);
  const { currentCompany } = useSelector((state: any) => state.configurations);

  const { loading, users } = useSelector((state: any) => state.users);
  const [tableHeaders, setTableHeaders] =
    useState<Record<string, Record<string, string | number | boolean>>>(
      headers
    );
  const fetchUsers = () => {
    dispatch(getAllUsers(currentCompany._id || ""));
  };
  const { isLargeDevice, isMediumDevice, isSmallDevice } = useContext(
    DeviceOrientationContext
  );

  useEffect(() => {
    setRefresh(false);
    let isMounted = true;

    if (isMounted) {
      fetchUsers();

      setTableHeaders(
        isLargeDevice
          ? headers
          : isMediumDevice
          ? MediumDeviceHeaders
          : SmallDeviceHeaders
      );
    }

    return () => {
      isMounted = false;
    };
  }, [isRefresh]);

  const handleSearch = (searchedText: string) => {
    if (searchedText && searchedText != "") {
      dispatch(searchAllUsers(searchedText));
    }
  };

  const navigateToOrder = (userId: string, mode: string) => {
    navigation.navigate("BypassUserDetails", { mode: mode, userId: userId });
  };

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
    >
      <View style={styles.headerContainer}>
        <TouchableOpacity style={[styles.addButton, { marginRight: 10 }]}>
          <Text
            style={[styles.buttonText]}
            onPress={() =>
              navigation.navigate("CreateUser", { screen: "AddUserScreen" })
            }
          >
            Add User
          </Text>
        </TouchableOpacity>
        <LabelBannerWithSearchBar
          titleName={`Total Users: ${users.length}`}
          handleSearch={handleSearch}
          setRefresh={setRefresh}
          dataToExport={users}
          fileName="UsersReportScreen"
          sheetName="Users Report"
        />
      </View>
      <View style={{ width: "100%" }}>
        <NestedDataTable
          itemsPerPage={15}
          isNestedDataLoaded={loading}
          nestedHeader={tableHeaders}
          nestedRows={users}
          key="rowKeyValue"
          userActions={navigateToOrder}
          userActionsKey="email"
        />
      </View>
      <Modal.ModalContainer
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        childern={CreateOktaBypassUserAccountForm}
      />
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    paddingHorizontal: 20,
    marginVertical: 10,
  },
  container: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
  },
  contentContainer: {
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
  },
  addButton: {
    backgroundColor: "#6495ED",
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 5,
  },
  buttonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "bold",
  },
  userCard: {
    backgroundColor: "#f9f9f9",
    padding: 15,
    marginVertical: 10,
    borderRadius: 10,
    width: "90%",
  },
  userName: {
    fontSize: 16,
    fontWeight: "bold",
  },
  userRole: {
    fontSize: 14,
    color: "grey",
  },
  modalContainer: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 10,
    width: "90%",
    alignSelf: "center",
  },
  modalHeader: {
    marginBottom: 20,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  modalContent: {
    alignItems: "center",
  },
  label: {
    fontSize: 14,
    marginVertical: 10,
    fontWeight: "bold",
    alignSelf: "flex-start",
  },
  input: {
    width: "100%",
    padding: 10,
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 5,
    marginBottom: 15,
  },
});
